import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fullListShape } from 'constants/PropTypesShapes';
// HOCS
import withFormManagement from 'hocs/WithFormManagement';
// Models
import {
  name,
  listFeatures,
  queListWorkspaceGroups,
} from 'models/cpm/workspaceGroup';
// Custom
import { cpmListWorkspaceGroups } from 'actions';
import { buildListSpecs } from 'utils/Tools';
import SubListTemplate from 'components/templates/SubListTemplate';
import WorkspaceGroupRow from 'cpmWorkspaces/assets/workspaceGroup/WorkspaceGroupRow';
import WorkspaceGroupFilters from 'cpmWorkspaces/assets/workspaceGroup/WorkspaceGroupFilters';

class WorkspaceGroupChooseList extends React.Component {
  constructor(props) {
    super(props);

    this.handleSelectWorkspaceGroups = this.handleSelectWorkspaceGroups.bind(this);
    this.handleValidate = this.handleValidate.bind(this);
    this.doGetRowComp = this.doGetRowComp.bind(this);

    // Build list specs: permanent filters
    const { permanentFiltersSpecs } = this.props;
    this.listSpecs = buildListSpecs(
      listFeatures.searchFields,
      permanentFiltersSpecs,
    );
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  // Handlers
  handleSelectWorkspaceGroups(workspaceGroup) {
    const { onFieldsChange } = this.props;
    onFieldsChange({ selectedWorkspaceGroups: workspaceGroup });
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const {
      fields: { selectedWorkspaceGroups },
      onValidate,
    } = this.props;

    onValidate(selectedWorkspaceGroups);

    return true;
  }

  doGetRowComp(props) {
    return <WorkspaceGroupRow {...props} />;
  }

  render() {
    const {
      fields: { selectedWorkspaceGroups },
      workspaceId,
      workspaceGroups,
      handleListWorkspaceGroups,
    } = this.props;
    // List specs
    const { excludedFilterFields, permanentFilters } = this.listSpecs;

    return (
      <SubListTemplate
        withQueryParams={false}
        name={name}
        listFeatures={listFeatures}
        withSelection
        multiSelectable
        onSelectElements={this.handleSelectWorkspaceGroups}
        elementsData={{
          loading: workspaceGroups.loading,
          selectedElements: selectedWorkspaceGroups,
          elements: workspaceGroups.elements,
          handleGetList: (p, s, f) => handleListWorkspaceGroups({ workspaceId }, p, s, f),
        }}
        permanentFilters={permanentFilters}
        excludedFilterFields={excludedFilterFields}
        filtersComp={<WorkspaceGroupFilters />}
        rowComp={this.doGetRowComp}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  workspaceGroups: state.cpmWorkspaceGroup.list,
});

const mapDispatchToProps = (dispatch) => ({
  handleListWorkspaceGroups: (data, pagination, sort, filters) => {
    dispatch(
      cpmListWorkspaceGroups(queListWorkspaceGroups, data, {
        pagination,
        sort,
        filters: [
          ...filters,
          listFeatures.ONLY_REGULAR_FILTER,
        ],
      }),
    );
  },
});

WorkspaceGroupChooseList.propTypes = {
  fields: PropTypes.object.isRequired,
  workspaceGroups: fullListShape.isRequired,
  workspaceId: PropTypes.number.isRequired,
  permanentFiltersSpecs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    }),
  ),
  handleListWorkspaceGroups: PropTypes.func.isRequired,
  onFieldsChange: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

WorkspaceGroupChooseList.defaultProps = {
  permanentFiltersSpecs: null,
};

const mapFieldsToProps = {
  selectedWorkspaceGroups: {
    resourceKey: 'selectedWorkspaceGroups',
    defaultValue: [],
  },
};

module.exports = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withFormManagement(mapFieldsToProps, null),
)(WorkspaceGroupChooseList);



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/assets/workspaceGroup/WorkspaceGroupChooseList.js